/* eslint-disable react/jsx-indent-props */
/* eslint-disable max-depth */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable max-statements */
/* eslint-disable no-alert */
/* eslint-disable no-console */
/* eslint-disable no-magic-numbers */
/* eslint-disable complexity */
import {Container, Typography, Button, Box, Alert} from '@deere/fuel-react';
import {FormPasswordIssue} from '../components/forms/FormPasswordIssue';
import ModalCountryPhones from '../components/modal/ModalCountryPhones';
import ModalPasswords from '../components/modal/ModalPasswords';
import '../css/margin.style.css';
import {BusinessLabel} from '../components/custom/BusinessLabel';
import {useDispatch, useSelector} from 'react-redux';
import {useLocation} from 'react-router-dom';
import {useForm} from 'react-hook-form';
import {useEffect, useState} from 'react';
import {createSnowIncident} from '../services/ticket.service';
import {getContactUsParams, getContactUsApps} from '../services/snow.service';
import {setParams} from '../redux/features/param/param.slice';
import {constants} from '../util/constants';
import {formDefaultValues} from '../util/formDefaultValues';
import {verifyContactUsFormData} from '../util/validations';
import {setApps} from '../redux/features/apps/app.slice';
import {sortAppsByName} from '../util/sort';
import IncidentGenericForm from '../components/forms/IncidentGenericForm';
import IncidentEDIForm from '../components/forms/IncidentEDIForm';
import IncidentContactForm from '../components/forms/IncidentContactForm';
import IncidentCollabForm from '../components/forms/IncidentCollabForm';
import IncidentSGAForm from '../components/forms/IncidentSGAForm';
import {useOktaAuth} from '@okta/okta-react';

export default function Home() {
    const {authState} = useOktaAuth();
    const [loading, setLoading] = useState(false);
    const isPasswordIssue = useSelector((state) => state.passwordIssue.value);
    const [displayAlert, setDisplayAlert] = useState({
        display: false,
        title: '',
        variant: '',
        message: ''
    });
    const [files, setFiles] = useState([]);
    const formSelection = {
        selection: undefined,
        fields: {},
        jdsnAppSelection: undefined,
        jdsnAppName: undefined,
        appId: undefined
    };
    const selectedApp = useSelector((state) => state.select.selectedValue);
    const selectedAppName = useSelector((state) => state.select.selectedAppName);
    const dispatch = useDispatch();

    const {search} = useLocation();
    const usrId = typeof search === 'string' && search.length > 0 ? new URLSearchParams(search.trim().toUpperCase()).get(constants.URL_PARAMS.USERID) : '';
    const appId = typeof search === 'string' && search.length > 0 ? new URLSearchParams(search.trim().toUpperCase()).get(constants.URL_PARAMS.APPID) : '';
    const comments = typeof search === 'string' && search.length > 0 ? new URLSearchParams(search.trim().toUpperCase()).get(constants.URL_PARAMS.COMMENTS) : '';

    const {
        handleSubmit, register, formState: {errors}, setError, setValue
    } = useForm({
        defaultValues: formDefaultValues.defaultValues
    });

    const setFormDataToValidate = (data) => {
        if (data === undefined || data === null) {
            return;
        }
        switch (formSelection.selection) {
            case constants.FORM_SELECTION.ediFormOption:
                formSelection.fields = {
                    userId: data.userId,
                    userName: data.userName,
                    jobTitle: data.jobTitle,
                    comments: data.comments,
                    partNumber: data.partNumber,
                    purchaseOrder: data.purchaseOrder,
                    supplierNumber: data.supplierNumber,
                    supplierName: data.supplierName,
                    appUrl: data.appUrl,
                    files: data.files,
                    email: data.email,
                    phone: data.phone
                };
                break;
            case constants.FORM_SELECTION.ediRegionTwoFormOption:
                formSelection.fields = {
                    userId: data.userId,
                    userName: data.userName,
                    jobTitle: data.jobTitle,
                    comments: data.comments,
                    ediR2PartNumber: data.ediR2PartNumber,
                    ediR2PurchaseOrder: data.ediR2PurchaseOrder,
                    ediR2PlantCode: data.ediR2PlantCode,
                    ediR2SupplierNumber: data.ediR2SupplierNumber,
                    ediR2Document: data.ediR2Document,
                    supplierNumber: data.supplierNumber,
                    supplierName: data.supplierName,
                    appUrl: data.appUrl,
                    files: data.files,
                    email: data.email,
                    phone: data.phone
                };
                break;
            case constants.FORM_SELECTION.supplierFormOption:
                formSelection.fields = {
                    userId: data.userId,
                    userName: data.userName,
                    jobTitle: data.jobTitle,
                    comments: data.comments,
                    impactedUserFirstName: data.impactedUserFirstName,
                    impactedUserMiddleInit: data.impactedUserMiddleInit,
                    impactedUserLastName: data.impactedUserLastName,
                    impactedUserJobTitle: data.impactedUserJobTitle,
                    impactedUserEmail: data.impactedUserEmail,
                    impactedSupplierNumber: data.impactedSupplierNumber,
                    impactedSupplierName: data.impactedSupplierName,
                    supplierNumber: data.supplierNumber,
                    supplierName: data.supplierName,
                    appUrl: data.appUrl,
                    files: data.files,
                    email: data.email,
                    phone: data.phone
                };
                break;
            case constants.FORM_SELECTION.genericFormOption:
                formSelection.fields = {
                    userId: data.userId,
                    userName: data.userName,
                    jobTitle: data.jobTitle,
                    comments: data.comments,
                    supplierNumber: data.supplierNumber,
                    supplierName: data.supplierName,
                    appUrl: data.appUrl,
                    files: data.files,
                    email: data.email,
                    phone: data.phone
                };
                break;
            case constants.FORM_SELECTION.collabFormOption:
                formSelection.fields = {
                    userId: data.userId,
                    userName: data.userName,
                    jobTitle: data.jobTitle,
                    comments: data.comments,
                    customOption: data.customOption,
                    supplierNumber: data.supplierNumber,
                    supplierName: data.supplierName,
                    appUrl: data.appUrl,
                    files: data.files,
                    email: data.email,
                    phone: data.phone
                };
                break;
            case constants.FORM_SELECTION.supplierGrouping:
                formSelection.fields = {
                    userId: data.userId,
                    userName: data.userName,
                    jobTitle: data.jobTitle,
                    comments: data.comments,
                    customOption: data.customOption,
                    supplierNumber: data.supplierNumber,
                    supplierName: data.supplierName,
                    appUrl: data.appUrl,
                    files: data.files,
                    email: data.email,
                    phone: data.phone
                };
                break;
            default:
                break;
        }
    };

    const handleCancel = () => {
        sessionStorage.clear();
        location.href = '/';
    };

    const onSubmit = async (data) => {
        sessionStorage.clear();
        setDisplayAlert({
            display: false,
            title: '',
            variant: '',
            message: ''
        });

        setFormDataToValidate(data);
        const hasErrors = verifyContactUsFormData(formSelection, setError);

        if (!hasErrors) {
            setLoading(true);
            formSelection.appId = typeof appId === 'string' && appId.trim().length > 0 ? appId : formSelection.jdsnAppSelection;
            formSelection.jdsnAppName = typeof selectedAppName === 'string' && selectedAppName.trim().length > 0 ? selectedAppName : formSelection.jdsnAppSelection;
            formSelection.fields.files = files;
            const response = await createSnowIncident(authState.accessToken.accessToken, formSelection);

            if (response && response.Incident) {
                sessionStorage.setItem('incidentValue', response.Incident);
            } else if (response && 'StatusMessage' in response && response.StatusMessage.trim().toLowerCase() === constants.USER_NOT_FOUND.FROM_API_MESSAGE.trim().toLowerCase()) {
                setDisplayAlert({
                    display: true,
                    title: constants.ALERT_VARIANT.error.title,
                    variant: constants.ALERT_VARIANT.error.variant,
                    message: constants.USER_NOT_FOUND.ERROR_MESSAGE
                });
            } else {
                setDisplayAlert({
                    display: true,
                    title: constants.ALERT_VARIANT.error.title,
                    variant: constants.ALERT_VARIANT.error.variant,
                    message: response && 'StatusMessage' in response ? response.StatusMessage : ''
                });
            }
            setLoading(false);
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
            window.location.reload();
        } else {
            setDisplayAlert({
                display: true,
                title: constants.ALERT_VARIANT.error.title,
                variant: constants.ALERT_VARIANT.error.variant,
                message: 'Some required fields are missing'
            });
            setLoading(false);
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
        }
    };

    const pullCorrectForm = (selected) => {
        if (typeof selected === 'string' && selected.trim().length > 0) {
            const isRegionTwo = selected.trim().toUpperCase() === constants.EDI_REGION_TWO;
            const isEdi = selected.includes(constants.EDI) && selected.trim().toUpperCase() !== constants.EDI_REGION_TWO;
            const isCollab = selected === constants.COLLAB || selected.includes(constants.COLLABORATION);
            const isSuppGrouping = selected === constants.SGA || selected.includes(constants.SGA);
            const isGeneric = [isRegionTwo, isEdi, isCollab, isSuppGrouping].includes(true); // validates if any custom form was selected

            formSelection.jdsnAppSelection = selected;
            formSelection.jdsnAppName = selectedAppName;
            if (!isGeneric) {
                formSelection.selection = constants.FORM_SELECTION.genericFormOption;
                return (<IncidentGenericForm
                    comments={comments}
                    errors={errors}
                    register={register}
                    setFiles={setFiles}
                    setValue={setValue}
                    usrId={usrId}
                />);
            }

            if (isRegionTwo) {
                formSelection.selection = constants.FORM_SELECTION.ediRegionTwoFormOption;
                return (
                    <IncidentEDIForm
                        comments={comments}
                        errors={errors}
                        isRegionTwo={true}
                        register={register}
                        setFiles={setFiles}
                        setValue={setValue}
                        usrId={usrId}
                    />
                );
            }

            if (isEdi) {
                formSelection.selection = constants.FORM_SELECTION.ediFormOption;
                return (
                    <IncidentEDIForm
                        comments={comments}
                        errors={errors}
                        register={register}
                        setFiles={setFiles}
                        setValue={setValue}
                        usrId={usrId}
                    />
                );
            }

            if (isCollab) {
                formSelection.selection = constants.FORM_SELECTION.collabFormOption;
                return (<IncidentCollabForm
                    comments={comments}
                    errors={errors}
                    register={register}
                    setFiles={setFiles}
                    setValue={setValue}
                    usrId={usrId}
                />);
            }

            if (isSuppGrouping) {
                formSelection.selection = constants.FORM_SELECTION.supplierGrouping;
                return (<IncidentSGAForm
                    comments={comments}
                    errors={errors}
                    register={register}
                    setFiles={setFiles}
                    setValue={setValue}
                    usrId={usrId}
                />);
            }

            formSelection.selection = constants.FORM_SELECTION.supplierFormOption;
            return (<IncidentContactForm
                comments={comments}
                errors={errors}
                register={register}
                setFiles={setFiles}
                setValue={setValue}
                usrId={usrId}
            />);
        }
        return null;
    };

    const fetchContactUsParams = async () => {
        const params = await getContactUsParams(authState.accessToken.accessToken);

        if (Array.isArray(params)) {
            dispatch(setParams(params));
        }
    };

    const fetchContactUsApps = async () => {
        const apps = await getContactUsApps(authState.accessToken.accessToken);

        if (Array.isArray(apps)) {
            sortAppsByName(apps);
            dispatch(setApps(apps));
        }
    };

    useEffect(() => {
        fetchContactUsParams();
        fetchContactUsApps();
        if (isPasswordIssue) {
            setDisplayAlert({
                display: false,
                title: '',
                variant: '',
                message: ''
            });
        }
    }, [isPasswordIssue]);

    useEffect(() => {
        const incident = sessionStorage.getItem('incidentValue');

        if (incident) {
            setDisplayAlert({
                display: true,
                title: constants.ALERT_VARIANT.success.title,
                variant: constants.ALERT_VARIANT.success.variant,
                message: `Incident number : ${incident}`
            });
        }
    }, []);

    const buttons = (<div className='push-right mt-2'>
        <Button
            disabled={loading}
            onClick={handleCancel}
            variant='secondary'
        >{'Cancel'}</Button>
        <Button
            disabled={loading}
            onClick={handleSubmit(onSubmit)}
            style={{
                marginLeft: '10px'
            }}
            variant='primary'
        >{'Submit'}</Button>
    </div>);

    const home = (<Container fluid='true'>
        <Typography
            gutterBottom
            variant='h1'
        >
            {'Contact Us'}
        </Typography>
        <div className='mb-2'>
            <BusinessLabel/>
        </div>
        <div className='mb-2'>
            {displayAlert.display ? <Alert
                title={displayAlert.title}
                variant={displayAlert.variant}
            > {displayAlert.message}</Alert> : null}
        </div>
        <>
            <Box
                component={'form'}
                noValidate
            >
                <FormPasswordIssue
                    appId={appId}
                    errors={errors}
                    register={register}
                    setValue={setValue}
                />
                {pullCorrectForm(selectedApp)}
                {isPasswordIssue ? null : buttons}
            </Box>
        </>
        <>
            <ModalCountryPhones/>
            <ModalPasswords/>
        </>
    </Container>);

    return home;
}
